import { render, staticRenderFns } from "./appoint-checkbox.vue?vue&type=template&id=59fd8a4a&scoped=true&"
import script from "./appoint-checkbox.vue?vue&type=script&lang=js&"
export * from "./appoint-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./appoint-checkbox.vue?vue&type=style&index=0&id=59fd8a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd8a4a",
  null
  
)

export default component.exports